import { XDC_MAINLIST_PREFIX } from '../constants/lists'

const getTokenLogoURL = (address: string) => {
  return `${XDC_MAINLIST_PREFIX}/assets/${address}/logo.png`
}

export default getTokenLogoURL
